import type { BrandCategory } from '@innovationdepartment/proxima-sdk-axios';
import { Form } from '@innovationdepartment/proxima-ui';
import { useState } from 'react';
import ModalBase from 'ui/ModalBase';
import EditBrandProfileModalView from './EditBrandProfileModal.View';

type EditBrandProfileModalProps = {
  open: boolean;
  currentCategory?: BrandCategory;
  onClose: () => void;
  onUpdateBrandCategory: (category: BrandCategory) => Promise<void> | void;
};

const EditBrandProfileModal = (props: EditBrandProfileModalProps) => {
  const { open, currentCategory, onClose, onUpdateBrandCategory } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (formData: { category?: BrandCategory }) => {
    const { category } = formData;
    if (!category) return;

    setIsSubmitting(true);
    await onUpdateBrandCategory(category);
    setIsSubmitting(false);
    onClose();
  };

  return (
    <ModalBase open={open} title="Edit brand profile" onClose={onClose} allowCloseOnClickOutside>
      <Form onSubmit={handleSubmit} initialValues={{ category: currentCategory }}>
        <EditBrandProfileModalView isSubmitting={isSubmitting} onClose={onClose} />
      </Form>
    </ModalBase>
  );
};

export default EditBrandProfileModal;
